import { Fragment } from "react"
import { Text } from "@mobi/ds"
import { If } from "@mobi/components"
import TokenListItem from "../TokenListItem"
import "./TokenList.scss"

const TokenList = ({ tokens }) => {
  return (
    <div className="token-list">
      {Object.keys(tokens).map((token) => (
        <Fragment key={token}>
          <If
            condition={typeof tokens[token] === "string"}
            renderIf={<TokenListItem name={token} value={tokens[token]} />}
            renderElse={
              <>
                <Text as="h2" className="icon-list__title">
                  {token}
                </Text>
                <div className="token-list__list-container">
                  {Object.keys(tokens[token]).map((item) => (
                    <TokenListItem
                      key={item}
                      name={item}
                      value={tokens[token][item]}
                    />
                  ))}
                </div>
              </>
            }
          />
        </Fragment>
      ))}
    </div>
  )
}

export default TokenList
